<template lang="pug">
  .abilityManagement.container
    h3.abilityManagement__title.col-md-12 職位管理
    .abilityManagement__wrapper.col-md-12
      p.abilityManagement__subtitle 職位選擇:
      select.abilityManagement__input.abilityManagement__input--selector(
        :value="selectedPositionId"
        @change="handleSelectedPositionChange($event)")
        option.abilityManagement__option(
          v-for="{ name, id } in positionIdAndNameList"
          :value="id") {{ name }}
        option.abilityManagement__option(value=-1) 新增職位
    .abilityManagement__wrapper.col-md-12
      p.abilityManagement__subtitle 職位名稱:
      input.abilityManagement__input(type="text"
        placeholder="輸入職位名稱"
        :class="{'abilityManagement__input--disabled': !isAddingPosition }"
        :value="selectedPositionName"
        :disabled="!isAddingPosition"
        @input="updatePositionName")
      BaseButton.abilityManagement__button(
        v-if="isAddingPosition"
        :text="'新增'"
        @click="addNewPosition")
      BaseButton.abilityManagement__button(
        v-if="!isAddingPosition && !isEditing"
        :text="'編輯'"
        @click="editCurrentAbility")
      BaseButton.abilityManagement__button(
        v-if="!isAddingPosition && !isEditing"
        :text="'刪除'"
        :backgroundColor="'#ea999a'"
        @click="deleteCurrentPosition")
      BaseButton.abilityManagement__button(
        v-if="isEditing"
        :text="'更新'"
        @click="updateCurrentPositionAbility")
      BaseButton.abilityManagement__button(
        v-if="isEditing"
        :text="'取消'"
        :backgroundColor="'#67c16a'"
        @click="cancelEditAbility")
    .abilityManagement__wrapper.abilityManagement__wrapper--table.col-md-12
      AbilityGroupDriverItems.abilityManagement__abilityGroup(
        :disabled="abilityEditable === false")
      AbilityGroupPhoneHailing.abilityManagement__abilityGroup(
        :disabled="abilityEditable === false")
      AbilityGroupCustomerItems.abilityManagement__abilityGroup(
        :disabled="abilityEditable === false")
      AbilityGroupDispatchItems.abilityManagement__abilityGroup(
        :disabled="abilityEditable === false")
      AbilityGroupUserManagement.abilityManagement__abilityGroup(
        :disabled="abilityEditable === false")
      AbilityGroupTransactionItems.abilityManagement__abilityGroup(
        :disabled="abilityEditable === false")
      AbilityGroupReservation.abilityManagement__abilityGroup(
        :disabled="abilityEditable === false")
      AbilityGroupMobilePayment.abilityManagement__abilityGroup(
        :disabled="abilityEditable === false")
      AbilityGroupAnnouncement.abilityManagement__abilityGroup(
        :disabled="abilityEditable === false")
      AbilityGroupUserDelete.abilityManagement__abilityGroup(
        :disabled="abilityEditable === false")
</template>
<script>
import PositionSelector from '@/pages/manager/PositionSelector'
import AbilityGroupDriverItems from '@/pages/manager/AbilityRadioGroup/AbilityGroupDriverItems'
import AbilityGroupTransactionItems from '@/pages/manager/AbilityRadioGroup/AbilityGroupTransactionItems'
import AbilityGroupCustomerItems from '@/pages/manager/AbilityRadioGroup/AbilityGroupCustomerItems'
import AbilityGroupReservation from '@/pages/manager/AbilityRadioGroup/AbilityGroupReservation'
import AbilityGroupDispatchItems from '@/pages/manager/AbilityRadioGroup/AbilityGroupDispatchItems'
import AbilityGroupMobilePayment from '@/pages/manager/AbilityRadioGroup/AbilityGroupMobilePayment'
import AbilityGroupUserManagement from '@/pages/manager/AbilityRadioGroup/AbilityGroupUserManagement'
import AbilityGroupPhoneHailing from '@/pages/manager/AbilityRadioGroup/AbilityGroupPhoneHailing'
import AbilityGroupAnnouncement from '@/pages/manager/AbilityRadioGroup/AbilityGroupAnnouncement'
import AbilityGroupUserDelete from '@/pages/manager/AbilityRadioGroup/AbilityGroupUserDelete'
import BaseButton from '@/components/common/button/BaseButton'
import { mapActions, mapGetters } from 'vuex'
import positionService from '@/API/positionService'

export default {
  data() {
    return {
      fullPage: false,
      loader: null,
      isEditing: false,
    }
  },
  computed: {
    ...mapGetters({
      selectedPositionId: 'positionStore/getSelectedPositionId',
      selectedPositionName: 'positionStore/getSelectedPositionName',
      positionIdAndNameList: 'positionStore/getPositionIdAndNameList',
    }),
    isAddingPosition() {
      return this.selectedPositionId === -1
    },
    abilityEditable() {
      return this.isEditing || this.isAddingPosition
    },
  },
  methods: {
    ...mapActions({
      postNewPosition: 'positionStore/postNewPosition',
      fetchPositionList: 'positionStore/fetchPositionList',
      updatePositionAbility: 'positionStore/updatePositionAbility',
      setSelectedPositionById: 'positionStore/setSelectedPositionById',
      setSeletedPositionName: 'positionStore/setSeletedPositionName',
    }),
    showLoading() {
      this.loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      })
    },
    handleSelectedPositionChange(event) {
      const { value } = event.target
      this.setSelectedPositionById(parseInt(value))
    },
    editCurrentAbility() {
      this.isEditing = true
    },
    cancelEditAbility() {
      this.isEditing = false
      this.setSelectedPositionById(this.selectedPositionId)
    },
    updatePositionName(event) {
      const { value } = event.target
      this.setSeletedPositionName(value)
    },
    async deleteCurrentPosition() {
      if (confirm(`確認刪除${this.selectedPositionName}?`)) {
        await positionService
          .deletePosition(this.selectedPositionId)
          .then(async () => {
            await this.fetchPositionList()
            alert('刪除成功')
          })
          .catch((err) => {
            alert(`刪除失敗 ${err}`)
          })
      }
    },
    async updateCurrentPositionAbility() {
      if (confirm(`確認更新${this.selectedPositionName}?`)) {
        await this.updatePositionAbility(this.selectedPositionId)
          .then(() => {
            this.isEditing = false
            alert('更新成功')
          })
          .catch((err) => {
            console.error(err)
            // alert(`更新失敗`);
          })
      }
    },
    async addNewPosition() {
      if (this.selectedPositionName === '') return alert('請輸入職位名稱')
      await this.postNewPosition()
        .then(async () => {
          alert('新增職位成功')
          await this.fetchPositionList()
        })
        .catch((err) => {
          alert(`新增失敗 ${err}`)
        })
    },
  },
  components: {
    PositionSelector,
    AbilityGroupDriverItems,
    AbilityGroupTransactionItems,
    AbilityGroupCustomerItems,
    AbilityGroupReservation,
    AbilityGroupDispatchItems,
    AbilityGroupMobilePayment,
    AbilityGroupUserManagement,
    AbilityGroupPhoneHailing,
    AbilityGroupAnnouncement,
    AbilityGroupUserDelete,
    BaseButton,
  },
  async mounted() {
    await this.showLoading()
    await this.fetchPositionList()
      .then(() => {
        this.loader.hide()
      })
      .catch((e) => {
        console.log(e)
        this.loader.hide()
      })
  },
}
</script>
<style lang="scss" scoped>
.abilityManagement {
  padding-left: 70px;
  background: #f7f7f7;
  padding-bottom: 20px;

  &__title {
    padding-top: 10px;
    padding-bottom: 20px;
    margin: 0;
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
  }

  &__wrapper {
    margin-top: 15px;
    display: flex;
    align-items: center;

    &--table {
      flex-wrap: wrap;
      align-items: flex-start;
    }
  }

  &__subtitle {
    font-size: 18px;
    font-weight: normal;
    margin: 0;
  }

  &__input {
    margin-left: 20px;
    padding: 6px 12px;
    font-size: 16px;
    color: #555;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: #fff;
    width: 250px;
    height: 36px;

    &--disabled {
      background: #c3c3c3;
    }
  }

  &__abilityGroup {
    margin-top: 10px;
    margin-left: 5px;
  }

  &__button {
    width: 100px;
    margin-left: 30px;
    height: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/manager/AbilityManagement.vue